var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import { TextWrapper } from '../subcomponents';
import StatusMessage from '../StatusMessageBox';
import SamsLink from '../../../modal/content/utils/SamsLink';
var NotEligibleMessageBox = function () {
    var samsLinkText = translate('notEligibleMessageBox.subtitle');
    var samsLink = _jsx(SamsLink, { children: samsLinkText });
    return (_jsx(StatusMessage, { iconTitle: "exclamation circle icon", type: "warning", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('notEligibleMessageBox.title'), messageDescription: _jsx(TextWrapper, { children: _jsx(Trans, __assign({ i18nKey: "notEligibleMessageBox", value: samsLink, components: { samsLink: samsLink } }, { children: translate('notEligibleMessageBox.subtitle', {
                    samsLinkText: samsLinkText
                }) })) }) }));
};
export default NotEligibleMessageBox;
